import { createAsyncThunk } from "@reduxjs/toolkit";
import { IDirectoryResponse } from "../../../api/types/directory/IResponse";
import { IReportInfo } from "../../../api/types/reports/IReportInfo";
import { AppDispatch } from "../../appDispatch";
import { RootState } from "../../rootState";
import { fetchDepartureCity } from "./fetchDepartureCity";
import { fetchDestinationCities } from "./fetchDestinationCities";
import { fetchDestinationCountries } from "./fetchDestinationCountries";
import { fetchOperators } from "./fetchOperators";

export const fetchDirectoryDataForTicketGridInfo = createAsyncThunk<
  IDirectoryResponse,
  IReportInfo,
  {
    state: RootState;
    dispatch: AppDispatch;
  }
>("ticketGrids/fetchDirectoryForTicketGridInfo", async (params, thunkAPI) => {
  await thunkAPI.dispatch(fetchOperators());
  await thunkAPI.dispatch(
    fetchDepartureCity({
      operatorId: 10,
    }),
  );
  await thunkAPI.dispatch(
    fetchDestinationCountries({
      operator: 10,
      departureCity: params.city_from,
      multiOperator: false,
    }),
  );
  await thunkAPI.dispatch(
    fetchDestinationCities({
      departureCity: params.city_from,
      operator: 10,
      destinationCountry: params.country,
    }),
  );

  const state = thunkAPI.getState();
  return {
    operators: state.directory.operators,
    departureCities: state.directory.departureCities,
    destinationCountries: state.directory.destinationCountries,
    destinationCities: state.directory.destinationCities,
  } as IDirectoryResponse;
});
